var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-6"},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-img',{attrs:{"src":require("../assets/logo.svg"),"max-width":_vm.logoWidth}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }